import VueUploadComponent from 'vue-upload-component';
// vue-upload-component/dist/vue-upload-component.d.ts
import Vue from 'vue';

Vue.component('FileUpload', VueUploadComponent);
